import { render, staticRenderFns } from "./Cleanup.vue?vue&type=template&id=08201ded&scoped=true"
import script from "./Cleanup.vue?vue&type=script&lang=js"
export * from "./Cleanup.vue?vue&type=script&lang=js"
import style0 from "./Cleanup.vue?vue&type=style&index=0&id=08201ded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08201ded",
  null
  
)

export default component.exports